// TODO eventually replace this with SearchField

import PropTypes from 'prop-types'

import InputTextField from 'components/common/InputTextField'
import theme from 'theme'

const SearchInput = ({ onChange, value, ...rest }) => {
  return (
    <InputTextField
      clearable
      search
      css={{ marginBottom: 0 }}
      id="search"
      label="Search..."
      maxWidth={theme.space[9]}
      name="search"
      type="text"
      value={value || ''}
      onChange={onChange}
      {...rest}
    />
  )
}

SearchInput.defaultProps = {
  value: ''
}

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
}

export default SearchInput
